module.exports = __webpack_public_path__ + "img/logo.fde0b1f2.webp";